export enum ContentTableTypeEnum {
  Campaigns = "campaigns",
  Playlists = "playlists",
}
